import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { CheckAccount } from '../type';
import type { CheckAccountModel } from './check-account-model.interface';
@injectable()
export class CheckAccountModelImpl
  extends AbstractModel<CheckAccount>
  implements CheckAccountModel
{
  _modelData: CheckAccount = {
    signIn: false,
    isLogin: null,
    phone: '',
    email: '',
  };

  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }
}
